// FilterBar.jsx
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { fetchstandardcategorien } from "../../../Reducers/actions";
import MultiSelectData from "../../../../../Components/Forms/multiselectdata";
import CheckboxGroup from "../../../../../Components/Forms/CheckboxGroup";

const FilterBar = ({ handleSubmit, initialize, onFilterChange, onSearchChange, onSortChange, search, sortBy, categorien, status, geboekt, categories }) => {
  const dispatch = useDispatch();
  const [showFilters, setShowFilters] = useState(false);

  // Load categories once
  useEffect(() => {
    dispatch(fetchstandardcategorien());
  }, [dispatch]);

  // Initialize form from cookie or defaults (run once)
  const [hasInit, setHasInit] = useState(false);
  useEffect(() => {
    if (hasInit || categories.length === 0) return;
    const saved = Cookies.get("kampeerplaatsen-filters");
    const defaultCatIds = categories.map((c) => c._id);
    const initial = saved ? JSON.parse(saved) : { categorien: defaultCatIds, status: [], geboekt: [] };

    initialize({
      categorien: Array.isArray(initial.categorien) ? categories.filter((c) => initial.categorien.includes(c._id)) : [],
      status: initial.status || [],
      geboekt: initial.geboekt || [],
    });
    setHasInit(true);
  }, [categories, initialize, hasInit]);

  // On change: update cookie and notify parent
  useEffect(() => {
    const catIds = categorien.map((c) => c._id);
    const filters = {
      categorien: catIds.length ? catIds : categories.map((c) => c._id),
      status,
      geboekt,
    };
    Cookies.set("kampeerplaatsen-filters", JSON.stringify(filters), { expires: 7 });
    onFilterChange?.(filters);
  }, [categorien, status, geboekt, categories, onFilterChange]);

  // Active badges
  const activeEntries = [];
  const allCatIds = categories.map((c) => c._id);
  const selectedCatIds = categorien.map((c) => c._id);
  if (selectedCatIds.length > 0 && !(selectedCatIds.length === allCatIds.length && allCatIds.every((id) => selectedCatIds.includes(id)))) {
    activeEntries.push(["categorien", categorien.map((c) => c.naam).join(", ")]);
  }
  if (status.length) activeEntries.push(["status", status.join(", ")]);
  if (geboekt.length) activeEntries.push(["geboekt", geboekt.join(", ")]);

  return (
    <div className="filter-bar-container">
      <div className="d-flex align-items-center gap-2 mb-3">
        <div className="flex-grow-1">
          <label htmlFor="search-bar-0" className="search-label">
            <input id="search-bar-0" onChange={onSearchChange} type="text" aria-labelledby="search-bar-0-label" className="form-control" placeholder="Zoeken" value={search} />
          </label>
        </div>
        <div className="sort-dropdown">
          <select 
            className="form-select form-select-sm" 
            value={sortBy} 
            onChange={(e) => onSortChange?.(e.target.value)}
            style={{ minWidth: '160px' }}
          >
            <option value="naam">Sorteren op naam</option>
            <option value="boeking">Boeking eerst</option>
          </select>
        </div>
        <button className="filter-toggle-btn d-none d-md-block btn btn-outline-secondary btn-sm" onClick={() => setShowFilters(!showFilters)}>
          <i className="fas fa-cog"></i>
        </button>
      </div>

      {/* ▼ ACTIVE FILTERS DIRECT ONDER ZOEK + TANDWIEL */}
      {activeEntries.length > 0 && (
        <div className="active-filters mb-3 d-flex gap-2 flex-wrap">
          {activeEntries.map(([key, label]) => (
            <span key={key} className="badge bg-secondary">{`${key}: ${label}`}</span>
          ))}
        </div>
      )}

      <button className="filter-toggle-mobile d-md-none mb-3" onClick={() => setShowFilters(!showFilters)}>
        {showFilters ? "Verberg filters" : "Toon filters"}
      </button>

      {showFilters && (
        <form onSubmit={handleSubmit(() => {})} className="filters open">
          <div className="row g-3">
            {categories.length > 0 && (
              <div className="col-md-6">
                <Field name="categorien" component={MultiSelectData} options={categories} dataKey="_id" textField="naam" label="Categorieën" />
              </div>
            )}
            <div className="col-md-3">
              <Field name="status" component={CheckboxGroup} options={["Ja"]} label="Stroom ingeschakeld" />
            </div>
            <div className="col-md-3">
              <Field name="geboekt" component={CheckboxGroup} options={["Ja"]} label="Heeft boeking" />
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

const selector = formValueSelector("filterForm");
const mapStateToProps = (state) => {
  const { categorien = [], status = [], geboekt = [] } = selector(state, "categorien", "status", "geboekt") || {};
  return {
    categorien,
    status,
    geboekt,
    categories: state.standplaatsen.categorien || [],
  };
};

export default connect(mapStateToProps, { fetchstandardcategorien })(reduxForm({ form: "filterForm", enableReinitialize: true })(FilterBar));
